import {
    getLoggedInUserType
} from '@/helpers/loggedInUserStorage';
import UcaasVerificationService from '@/service/ucaasVerification.service';

export const UCAAS_VERIFICATION_COMPLETED = 'UcaasVerificationComplated';
export const UCAAS_VERIFICATION_PENDING = 'UcaasVerificationPending';

export const COMPANY_ADMIN_USER_TYPES = ['02', 'usertype02'];
export const CO_OWNER_USER_TYPES = ['05', 'usertype05'];
export const ASSET_MANAGER_USER_TYPES = ['21', 'usertype21'];
export const EXTERNAL_VERIFICATION_USER_TYPES = [
    ...CO_OWNER_USER_TYPES,
    ...ASSET_MANAGER_USER_TYPES
];
export const UCAAS_GATED_USER_TYPES = [
    ...COMPANY_ADMIN_USER_TYPES,
    ...EXTERNAL_VERIFICATION_USER_TYPES
];

function normalizeUserType(value) {
    return String(value || '').trim().toLowerCase();
}

function resolveUserType(userType) {
    return userType != null && userType !== ''
        ? normalizeUserType(userType)
        : getLoggedInUserType();
}

export function getUcaasVerificationStatus() {
    return localStorage.getItem('ucaasVerification') || '';
}

export function setUcaasVerificationStatus(status) {
    if (!status) {
        localStorage.removeItem('ucaasVerification');
        return;
    }
    localStorage.setItem('ucaasVerification', status);
}

export function isUcaasVerificationCompleted() {
    return getUcaasVerificationStatus() === UCAAS_VERIFICATION_COMPLETED;
}

export function isCompanyAdminVerificationUser(userType) {
    return COMPANY_ADMIN_USER_TYPES.includes(resolveUserType(userType));
}

export function isExternalVerificationUser(userType) {
    return EXTERNAL_VERIFICATION_USER_TYPES.includes(resolveUserType(userType));
}

export function shouldGateCommunicationByUcaasVerification(userType) {
    return UCAAS_GATED_USER_TYPES.includes(resolveUserType(userType));
}

export function canShowCommunicationModule(userType) {
    if (!shouldGateCommunicationByUcaasVerification(userType)) {
        return true;
    }
    return isUcaasVerificationCompleted();
}

export function shouldShowPendingVerificationButton(userType) {
    return shouldGateCommunicationByUcaasVerification(userType) && !isUcaasVerificationCompleted();
}

export function applyVerificationApiResult(verificationStatus) {
    const normalized = String(verificationStatus || '').trim().toLowerCase();
    if (normalized === 'completed') {
        setUcaasVerificationStatus(UCAAS_VERIFICATION_COMPLETED);
        return UCAAS_VERIFICATION_COMPLETED;
    }

    setUcaasVerificationStatus(UCAAS_VERIFICATION_PENDING);
    return UCAAS_VERIFICATION_PENDING;
}

export async function runUcaasVerification(userType) {
    const companyId = localStorage.getItem('companyId');
    const resolvedUserType = resolveUserType(userType);

    if (!companyId) {
        throw new Error('Company context is missing.');
    }

    if (isCompanyAdminVerificationUser(resolvedUserType)) {
        return UcaasVerificationService.verifyCompany(companyId);
    }

    if (isExternalVerificationUser(resolvedUserType)) {
        const userId = localStorage.getItem('userId');
        if (!userId) {
            throw new Error('User context is missing.');
        }
        return UcaasVerificationService.verifyExternalUser(companyId, userId);
    }

    throw new Error('UCaaS verification is not required for this user type.');
}
